module.exports = __webpack_public_path__ + "media/landing_page/lp4-hero-desktop-02-f435c77a.jpg";